import $ from 'jquery';
import _ from "underscore";
import { isPresent, shallAllowClick } from "../../utilities/general";
import render from "../../utilities/render";
import { setElementsFromScope } from '../../utilities/selectorHelpers';
const productRowHtml = require('./html/productRow.html');
const unitOfMeasureHtml = require('./html/unitOfMeasure.html');
const productIdHtml = require('./html/productId.html');
const unitPillHtml = require('./html/unitPill.html');
const bundleChildBodyHtml = require('./html/bundleChildBody.html');
const uomDropdownOption = require('./html/uomDropdownOption.html');
const modalHtml = require("../../sharedHtml/modal.html");
const removeProductModalBodyHtml = require('./html/removeProductModalBody.html');
const skuInvalidErrorHtml = require('./html/skuInvalidError.html');
const missingHsCodeHtml = require('./html/missingCodeError.html');
const skuInactiveHtml = require('./html/skuInactive.html');

const elementsPageMap = {
  orderFulfillmentCenter: '#order-fulfillment-center',
  productItemLookup:"#product-item-lookup",
  productsTabValidatorElement :"#products-empty-table-validator",
  createOrderTableWrapper:".create-order-table-wrapper",
  productsEmpty:".products-empty",
  productOrBundleRow:"#product-bundle-row",
  autoFulfillToggle:".auto-fulfill",
  prodcutTabAvailableUnits: ".product-tab-available-units",
  orderTypeSelect:"#destination-tab-order-type-select",
  dropShipFlag:"#dropShipFlag",
  collateralInfoMsg:".edit-order-collateral-info-message",
  channelInfoMag:".edit-channel-order-info-message"
};

export default function ProductsTab(wizard) {
  const self = this;
  const elsPage = {};
  const wizardElement = wizard.getWizardElement();
  const typeAheadUrl = wizardElement.data("get-product-names-and-items-url");
  const portletNamespace = wizardElement.data("portlet-namespace");
  const facilityToggleTargetArray = [".auto-fulfill",".indianapolis", ".fontana",".greenwoodeast"];
  const orderDetailsForEdit = wizardElement.data("edit-order-details");
  let prevOrderTypeVal, prevDropShipVal, partnerId, removeId, removeProductModal = null;
  const nonChannelParIds = [3,5,7];
  let businessExceptionsExist=false;
  self.productItems = {};
  self.productNameArr = {};
  let currentItemList = [];
  const detailsForItemOnOrder = wizardElement.data("item-detail-info");

   self.init = function() {
    setElements();
    setWidgets();
    bindElements();
    populateProductsForEdit();
  };

  self.didNavigateToForm = function() {
    configureUOMDropdownBasedonOrderTypeAndDropShip();
    handleDisplayOfCreateOrderTable();
  };

  self.isValid = function(){
    return (getItemsInCreateOrderTable().length);
  };

  function handleDisplayOfCreateOrderTable() {
    if(getItemsInCreateOrderTable().length) {
      hide(elsPage.productsEmpty);
      show(elsPage.productOrBundleRow);
    } else {
      hide(elsPage.productOrBundleRow);
      show(elsPage.productsEmpty);
    }
  }

  function getItemsInCreateOrderTable() {
    return elsPage.productOrBundleRow.find('.product-data-row');
  }

  function hide(el) {
    el.css({display: "none"});
  }

  function show(el) {
    el.css({display: "block"});
  }

  function setElements() {
    setElementsFromScope(elsPage, elementsPageMap, wizardElement);
  }

  function setWidgets() {
    loadFulfillmentDropdown();
    instantiateSkuTypeAhead();
    const productItemLookup = elsPage.productItemLookup;
    productItemLookup.on("select2:select", function(e) {
        let res = e.params.data.text.split("--");
        addProducts(res[0],'',res[1],res[2],res[3],'');
        triggerAddProductsEvent();
        productItemLookup.val(null).trigger('change');
    });
  }

  function loadFulfillmentDropdown() {
    let facilities = elsPage.orderFulfillmentCenter.data('options');
    $(facilities).each(function(){
      const option = $('<option />');
      option.attr('value', this.cadFacId).text(this.cadLocationName);
      option.data('quick-toggler-target', facilityToggleTargetArray[(this.cadFacId)]);
      elsPage.orderFulfillmentCenter.append(option);
    });
  }

  function bindElements() {
    elsPage.productOrBundleRow.on('addedproducts', handleAddProducts);
    elsPage.orderFulfillmentCenter.on("change", handleFacilityOnChange);
    wizardElement.on('click', '#product-bundle-row .product-data-row .product-remove-btn', handleItemRemove);
    wizardElement.on('change', '#product-bundle-row .product-data-row .products-tab-uom', handleUOMChange);
    $('body').on('click', '.channel-remove-product-btn', handleChannelProductRemovalModal);
  }

  function populateProductsForEdit() {
    if(isPresent(orderDetailsForEdit)) {
      const facId = orderDetailsForEdit.orderDetails.ordFacId;
      partnerId = orderDetailsForEdit.orderDetails.ordParId;
      prevOrderTypeVal = orderDetailsForEdit.orderDetails.ordOrderType;
      prevDropShipVal = isPresent(orderDetailsForEdit.orderDetails.ordDropShip)?orderDetailsForEdit.orderDetails.ordDropShip:false;

      show(elsPage.collateralInfoMsg);
      if(!nonChannelParIds.includes(partnerId)) {
        show(elsPage.channelInfoMag);
      }

      if(isPresent(facId)) {
        elsPage.orderFulfillmentCenter.val(facId).trigger("change");
      }

      //let products = orderDetailsForEdit.orderDetails.orderItems;
      let groupedProducts = groupTheProducts(orderDetailsForEdit.orderDetails.orderItems);
      let productKeys = _.keys(groupedProducts);
      let skus = [];
      _.each(productKeys, function(item) {
        if(isPresent(groupedProducts[item][0].oriKitSku)) {
          skus.push(groupedProducts[item][0].oriKitSku);
        } else {
          skus.push(groupedProducts[item][0].oriItmSku);
        }
      });

      if(skus.length > 0) {
        $.ajax({
          url: typeAheadUrl,
          type: 'POST',
          data: {
            'facId': facId,
            'skuList': skus
          },
          dataType: 'JSON',
          success: function(data) {
            getProductNamesAndItems(data);
            //let items = data.items;
            let counter = 0;
            _.each(productKeys, function(item) {
              let currentSku, qty, uom, oriStatus, parItmId,parOriId = null;
              if(isPresent(groupedProducts[item][0].oriKitSku)) {
                currentSku = groupedProducts[item][0].oriKitSku;
                for(let i =0; i<groupedProducts[item].length; i++){
                  if(parOriId != null)
                  parOriId = parOriId + groupedProducts[item][i].oriItmSku + ":" +groupedProducts[item][i].oriId + ",";
                  else
                  parOriId = groupedProducts[item][i].oriItmSku + ":" +groupedProducts[item][i].oriId + ",";
                }
              } else {
                currentSku = groupedProducts[item][0].oriItmSku;
                parOriId = groupedProducts[item][0].oriId;
              }
              qty = groupedProducts[item][0].oriOrderedUomQty;
              uom = groupedProducts[item][0].oriOrderedQtyUoM;
              oriStatus = groupedProducts[item][0].oriStatus;
              parItmId = groupedProducts[item][0].oriParItmId;
              let currentProduct = filterItem(currentSku);
              if(currentProduct.length > 0){
                addProducts(currentProduct[0].itmSku, parItmId, currentProduct[0].product.prdName,currentProduct[0].availUnit,currentProduct[0].type,parOriId);
              }else{
                addProducts(currentSku, parItmId, "Invalid Sku", "0" ,oriStatus,parOriId);
              }

              triggerAddProductsEvent();
              let productsRows = getItemsInCreateOrderTable();

              $(productsRows[counter]).find(".products-tab-quantity-input").val(qty);
              if(uom === "EA") {
                $(productsRows[counter]).find(".products-tab-uom").val("Units").trigger("change");
              } else if(uom === "CA") {
                $(productsRows[counter]).find(".products-tab-uom").val("Cases").trigger("change");
              } else {
                $(productsRows[counter]).find(".products-tab-uom").val("Pallets").trigger("change");
              }
              //$(productsRows[counter]).find(".products-tab-uom").attr("readonly", true);
              //$("#product-item-lookup").prop("readonly", true);
              /*if it's channel order make add products search button, qty and uom readonly*/
              if(!nonChannelParIds.includes(partnerId)) {
                $(productsRows[counter]).find(".products-tab-quantity-input").prop("readonly", true);
                $(".product-item-lookup-div").hide();
              }

              counter++;
            });
          }
        });
      }
    }
  }

  function groupTheProducts(orderLineItems) {
     let groupedProducts = _.groupBy(orderLineItems, 'oriLineId');
      /**
        For collateral skus we are going to have null as a key and we shouldn't
        show the collaterals as part of edit. so remove the null key from
        grouped products.
      **/
      if(_.has(groupedProducts, "null")) {
        groupedProducts = _.omit(groupedProducts, "null");
      }
      return groupedProducts;
  }

  function handleUOMChange(e) {
    let uomEl = $(e.target);
    let currentRow = uomEl.closest(".product-data-row");
    calculateAvailabilityBasedonUOM(currentRow, uomEl.val());
  }

  function calculateAvailabilityBasedonUOM(currentRow, uom) {
    //let skuEl = currentRow.find(".products-tab-sku");
    //let sku = $(skuEl).val();
    let availUnitsEl = currentRow.find(".products-tab-avail-units");
    let availUnits =  currentRow.find(".availableUnitsOfProduct").text();
    let unitsperuom = 0;
    if(uom === "Cases") {
      let unitsPerCaseEl = currentRow.find(".prod-tab-unitsPerCase");
      unitsperuom = $(unitsPerCaseEl).val();
    } else if(uom === "Pallets") {
      let unitsPerPalletEl = currentRow.find(".prod-tab-unitsPerPallet");
      unitsperuom = $(unitsPerPalletEl).val();
    } else {
      unitsperuom = 1;
    }
    let availUnitsperUOM = Math.floor(availUnits/unitsperuom);
    if(isNaN(availUnitsperUOM)) {
      availUnitsperUOM = 0;
    }
    $(availUnitsEl).html(renderUnitPill(availUnitsperUOM, uom));
  }

  function calculateAvailabilityForChildRow(currentRow, kitItems, uom) {
    let childRows = currentRow.find(".bundle-child-product-row");
    let rowsLength =$(childRows).length;
    _.each(kitItems, (kitItem)=>{
      for(let i=0; i<rowsLength; i++) {
        let skuEl = $(childRows[i]).find(".products-tab-child-product-name");
        let sku = $(skuEl).text();
        if(sku === kitItem.kitChildItmSku) {
          let childAvailUnitsEl = $(childRows[i]).find(".products-tab-child-available-units");
          $(childAvailUnitsEl).html(renderUnitPill(kitItem.availUnit, uom));
          break;
        }
      }
    });

  }

  function handleItemRemove(e) {
    if(isPresent(orderDetailsForEdit) && !nonChannelParIds.includes(partnerId)) {
      removeId = $(this).data("id");
      removeProductModal = $(render(
        modalHtml, {
        title: 'Channel Product Removal',
        topCloseBtn: true,
        autoHideTop: true,
        leftAlignTitle: true,
        modalDialogClass: 'q-modal-dialog-500',
        body: removeProductModalBodyHtml,
        footerBtns: `
          <a href="#" class="base-btn v2-btn purple-btn modal-auto-hide">Cancel</a>
          <a href="#" class="base-btn purple-btn channel-remove-product-btn">Remove Product</a>
        `
        }
      ));
      //add the modal to boday
      $('body').append(removeProductModal);
      removeProductModal.modal("show");
    } else {
      EditChecker.setPageDirty();
      removeProductRow($(e.target));
      handleDisplayOfCreateOrderTable();
    }
  }

  function handleChannelProductRemovalModal() {
    EditChecker.setPageDirty();
    $(`#${removeId}`).remove();
    removeProductModal.modal("hide");
    handleDisplayOfCreateOrderTable();
  }

  function removeProductRow(el) {
    const coreProduct = el.closest(".product-data-row");
    coreProduct.remove();
  }

  function handleFacilityOnChange() {
    const facId = elsPage.orderFulfillmentCenter.val();
    //const facName = $('#order-fulfillment-center :selected').text();
    if(isPresent(facId)) {
      hide(elsPage.autoFulfillToggle);
      //elsPage.prodcutTabAvailableUnits.html(`Available</br>(${facName})`);
      loadInventoryForFacility(facId);
    } else{
      show(elsPage.autoFulfillToggle);
      //elsPage.prodcutTabAvailableUnits.html('Available');
      loadInventoryForFacility(null);
    }
  }

  function configureUOMDropdownBasedonOrderTypeAndDropShip() {
    let productsRows = getItemsInCreateOrderTable();
    let noOfRows = getItemsInCreateOrderTable().length;
    if(noOfRows > 0 && doesOrderTypeorDropShipChanged()) {
      for(let i=0; i<noOfRows; i++) {
        let skuEl = $(productsRows[i]).find(".products-tab-sku");
        let sku = $(skuEl).val();
        if(isPresent(sku)) {
          let item = filterItem(sku);
          if(item != null && isPresent(item[0])) {
            let flag = evaluateUOMDropDown(item[0].itemsCaseDetails, item[0].type);
            let uomEl = $(productsRows[i]).find(".products-tab-uom");
            let uomDisable = $(uomEl).is(":disabled");
            /** set the uom dropdown value to units*/
            $(uomEl).val("Units").trigger("change");
            if(uomDisable && flag) {
              $(uomEl).prop("disabled", false);
            } else if(!uomDisable && !flag) {
              $(uomEl).prop('disabled', true);
            }
          }
        }
      }
    }
  }

  function doesOrderTypeorDropShipChanged() {
    let currentOrderTypeVal = elsPage.orderTypeSelect.val();
    let currentDropShipVal = elsPage.dropShipFlag.is(":checked");
    let isChanged = false;
    /*check for order type and drop ship change*/
    if((currentOrderTypeVal !== prevOrderTypeVal) ||
          (currentDropShipVal !== prevDropShipVal)) {
      isChanged = true;
      /* update the previous values with current
        values for next check*/
      prevOrderTypeVal = currentOrderTypeVal;
      prevDropShipVal = currentDropShipVal;
    }
    return isChanged;
  }

  function loadInventoryForFacility(facId) {
    let skus = [];
    let productsRows = getItemsInCreateOrderTable();
    let noOfRows = getItemsInCreateOrderTable().length;

    for(let i=0; i<noOfRows; i++) {
      let skuEl = $(productsRows[i]).find(".products-tab-sku");
      let sku = $(skuEl).val();
      if(isPresent(sku)) {
        skus.push(sku);
      }
    }

    if(skus.length > 0) {
      $.ajax({
        url: typeAheadUrl,
        type: 'POST',
        data: {
          'facId': facId,
          'skuList': skus
        },
        dataType: 'JSON',
        success: function(data){
          getProductNamesAndItems(data);
          let items = data.items;
          for(let i=0; i<noOfRows; i++) {
            let skuEl = $(productsRows[i]).find(".products-tab-sku");
            let sku = $(skuEl).val();
            if(isPresent(sku)) {
              let item = jQuery.map(items, function(obj) {
                  if(obj.itmSku === sku) return obj;
              });

              if(item != null && isPresent(item[0])) {
                $(productsRows[i]).find(".availableUnitsOfProduct").text(item[0].availUnit);
                let flag = evaluateUOMDropDown(item[0].itemsCaseDetails, item[0].type);
                let uomEl = $(productsRows[i]).find(".products-tab-uom");
                let uomDisable = $(uomEl).is(":disabled");
                /** set the uom dropdown value to units*/
                $(uomEl).val("Units").trigger("change");
                if(uomDisable && flag) {
                  $(uomEl).prop("disabled", false);
                } else if(!uomDisable && !flag) {
                  $(uomEl).prop('disabled', true);
                }
                calculateAvailabilityBasedonUOM($(productsRows[i]), $(uomEl).val());
                let kitItems = item[0].kitItems;
                if(isPresent(kitItems) && kitItems.length > 0) {
                  calculateAvailabilityForChildRow($(productsRows[i]), kitItems, "Units");
                }
              }
            }
          }
        }
      });
    }
  }

  function handleAddProducts() {
    EditChecker.setPageDirty();
    handleDisplayOfCreateOrderTable();
  }

  function instantiateSkuTypeAhead() {
    const select2AjaxDefaults = {
      dataType: 'json',
      delay: 250,
      processResults: function (data, params) {
        params.page = params.page || 1;
        return {
          results: getProductNamesAndItems(data),
          pagination: {
            more: (params.page * 20) < data.total_count
          }
        };
      },
      cache: true
    };

    function configureDataCallback({paramKey}) {
      return function(params){
        return {
          [paramKey] : params.term,
          "facId": elsPage.orderFulfillmentCenter.val()
        };
      };
    }

    elsPage.productItemLookup.select2({
      placeholder: "Begin typing a SKU to add to this order",
      allowClear: true,
      ajax: {
        ...select2AjaxDefaults,
        url: typeAheadUrl,
        cache: false,
        data: configureDataCallback({
            paramKey: 'likeSku'
        })
      },
      minimumInputLength: 3
    });
  }

  let triggerAddProductsEvent = function() {
    elsPage.productOrBundleRow.trigger('addedproducts');
  };

  function getProductNamesAndItems(response) {
    let items = response.items;
    self.productItems.regularItems = items;
    let productNameArr = response.productNameArr;
    self.productNameArr.regularItems = productNameArr;
    currentItemList = items;

    let intrnlItems = _.filter(response.items, filterInternationalItem);
    self.productItems.internationalItems = intrnlItems;

    let intrnlProductNameArr = _.filter(response.productNameArr, filterInternationalProductName);
    self.productNameArr.internationalItems = intrnlProductNameArr;

    let countryVal = $('#destination-tab-country  :selected').val();
    if(countryVal == 1) { // USA
      return productNameArr;
    } else {
      return intrnlProductNameArr;
    }
  }

  function filterInternationalItem(item) {
    if (item.itmInternationalShipping)
      return true;
    return false;
  }

  function filterInternationalProductName(item) {
    for (let i = 0; i < self.productItems.internationalItems.length; i++) {
      let itemObj = self.productItems.internationalItems[i];
      if (item.id == itemObj.itmSku)
        return true;
    }
    return false;
  }

  let addProducts = function(productName, parItmId, prodDescription,availUnit,prdType,parOriId) {
    let highestId = parseInt($("#product-bundle-row .product-data-row:last").attr("id"));
    if(isNaN(highestId)) {
      highestId = 0;
    } else {
      ++highestId;
    }

    let currentItem = filterItem(productName);
    let showErrorIconOnProductRow = showErrorIcon(productName, orderDetailsForEdit);
    const productRow = render(productRowHtml,{
        highestId: highestId,
        portletNamespace: portletNamespace,
        error: '',
        unitOfMeasure: renderUnitOfMeasure(prdType, currentItem[0], highestId),
        productId: renderProductId(productName, parItmId, prdType, showErrorIconOnProductRow, highestId,parOriId, portletNamespace),
        productDescription: prodDescription,
        productUnitsAvail: renderUnitPill(availUnit, "Units"),
        availProdUnits: availUnit,
        skuInvalid: renderSkuInvalidErrorHtml(productName, detailsForItemOnOrder, prdType),
        missingCode: renderMissingHsCodeHtml($('#destination-tab-country  :selected').val(), productName, detailsForItemOnOrder),
        skuInactive: renderSkuInactive(productName, detailsForItemOnOrder),
        children: renderBundleChildren(productName, currentItem[0])
    });
    elsPage.productOrBundleRow.append(productRow);
  };

  function renderUnitPill(unit, measure){
    let pillClass = unit > 0 ? 'q-pill-white-and-grey':'q-pill-red';
    return render(unitPillHtml, {
      pillClass,
      unit,
      measure
    });
  }

  function renderUnitOfMeasure(prdType, currentItem, highestId){
    let itemCaseDtls;
    if(currentItem!=null){
      itemCaseDtls = currentItem.itemsCaseDetails;
    }else{
      itemCaseDtls = [{"icdCaseType": "Master Case", "icdNumberOfUnits": "0"}]
    }
    let options = [{"id":"Units", "text":"Units"}];
    let unitsPerCase = 0;
    let unitsPerPallet = 0;
    if(isPresent(itemCaseDtls)) {
      _.each(itemCaseDtls, (itemCase)=>{
        let option = {};
        if(isPresent(itemCase.icdCaseType) &&
            itemCase.icdCaseType === "Pallet") {
          unitsPerPallet = itemCase.icdNumberOfUnits;
          option["id"] = "Pallets";
          option["text"] = `Pallets (${itemCase.icdNumberOfUnits} per Pallet)`;
          options.push(option);
        } else if(isPresent(itemCase.icdCaseType) &&
            itemCase.icdCaseType === "Master Case") {
          unitsPerCase = itemCase.icdNumberOfUnits;
          option["id"] = "Cases";
          option["text"] = `Cases (${itemCase.icdNumberOfUnits} per Case)`;
          options.push(option);
        }
      });
    }

    let dropDownOptions = _(options).map((item) => {
      let option = render(uomDropdownOption, {
          id: item.id,
          text: item.text
      });
      return option;
    });

    let isDisabled = evaluateUOMDropDown(itemCaseDtls, prdType) ? '' : 'disabled';
    return render(unitOfMeasureHtml,{
      highestId,
      isDisabled,
      dropDownOptions,
      unitsPerCase,
      unitsPerPallet
    });
  }

  function evaluateUOMDropDown(itemCaseDtls, prdType) {
    let count = 0;
    const facId = elsPage.orderFulfillmentCenter.val();
    if(isPresent(facId)) {
      let currentFacility = filterFacility(parseInt(facId));
      if(isPresent(currentFacility[0]) &&
          isPresent(currentFacility[0].cmrAddressAttributes)) {
        let attributes = currentFacility[0].cmrAddressAttributes;
        let uomAttribute = filterAttribute(attributes);
        if(isPresent(uomAttribute[0])) {
          count++;
        }
      }
    }

    if(isPresent(itemCaseDtls)) {
      count++;
    }

    let orderType = elsPage.orderTypeSelect.val();
    if(orderType === "B2B") {
      count++;
    } else if(orderType!="B2C" &&
      !(elsPage.dropShipFlag.is(":checked"))) {
      count++;
    }

    if(prdType != 'Bundle') {
      count++;
    }
    return (count === 4);
  }

  function filterFacility(facId) {
    let facilities = elsPage.orderFulfillmentCenter.data('options');
    return (_.filter(facilities, function(item){
      let cadFacId = parseInt(item.cadFacId);
      if(cadFacId === facId) {
        return true;
      }
    }));
  }

  function filterAttribute(attributes) {
    return (_.filter(attributes, function(item){
      if("UOM" === item.caaValue) {
        return true;
      }
    }));
  }

  function renderProductId(prodId, parItmId, prdType, error, highestId,parOriId, portletNamespace){
    let bundleIcon, errorIcon;
    if(prdType === 'Bundle') {
      bundleIcon = `<i class="fa fa-cubes q-icon-lg q-icon-marg-right" aria-hidden="true"></i>`;
    }
    if(error) {
      errorIcon = `<i class="fa fa-exclamation-circle q-icon-md q-icon-marg-right txt-c-red" aria-hidden="true"></i>`;
    }
      //prodId = `${prodId}`;
    return render(productIdHtml, {
      prodId,
      parItmId,
      errorIcon,
      bundleIcon,
      highestId,
      parOriId,
      portletNamespace
    });
  }

  function renderBundleChildren(productName, currentItem){
    if(currentItem !=null){
      const lineItem = (currentItem.kitItems).map((item)=>{
      return render(bundleChildBodyHtml, {
          productSku: item.kitChildItmSku,
          prodDesc: item.prdName,
          productUnitsAvail: renderUnitPill(item.availUnit, "Units")
        });
      });
      return lineItem.join('');
    }

  }

  function filterItem(productName) {
    return (_.filter(currentItemList, function(item){
      if(item.itmSku === productName) {
        return true;
      }
    }));
  }

  function renderSkuInvalidErrorHtml(item, detailsForItemOnOrder, prdType){
    if(prdType==="Invalid"){
      return render(skuInvalidErrorHtml, {
      });
    }
  }

  function renderMissingHsCodeHtml(country, item, detailsForItemOnOrder){
    if(isPresent(orderDetailsForEdit) && isPresent(detailsForItemOnOrder)){
      let currentSku = _.findWhere(detailsForItemOnOrder, {itmSku:item});
      if(country!=1){
        if(isPresent(currentSku) && item.length>0 && currentSku.itmHsCode==null){
          return render(missingHsCodeHtml, {

          });
        }else{
          return '';
        }
      }else{
        return '';
      }
    }else{
      return '';
    }
  }


  function renderSkuInactive(item,detailsForItemOnOrder){
    if(isPresent(detailsForItemOnOrder)){
      let currentSku = _.findWhere(detailsForItemOnOrder, {itmSku:item});
      if(isPresent(currentSku) && !currentSku.itmActive){
        return render(skuInactiveHtml, {
        });
      }else{
        return '';
      }
    }

  }

  self.checkIfBusinessExceptionsExist = function () {
    let businessExceptionsExist = false;
    let productRows = getItemsInCreateOrderTable();
    _.each(productRows, (productRow)=>{
       if(($(productRow).find(".sku-invalid-error")).length > 0 ||
                ($(productRow).find(".hs-code-missing")).length > 0 ||
                ($(productRow).find(".sku-inactive-error")).length > 0 ) {
          businessExceptionsExist = true;
       }
    });
    return businessExceptionsExist;
  }

 function showErrorIcon(currentItem, orderDetailsForEdit){
    let currentSku="";
    let showErrorIconForErrors = new Array("Invalid","NotIntlSku", "Inactive");
    if(isPresent(orderDetailsForEdit)){
      currentSku = _.findWhere(orderDetailsForEdit.orderDetails.orderItems, {oriItmSku:currentItem});
    }
    if(isPresent(currentSku) && _.contains(showErrorIconForErrors,currentSku.oriStatus)){
      return true;
    }else{
      return false;
    }
  }

}




// WEBPACK FOOTER //
// ./src/pages/order/ProductsTab.js